<h2 mat-dialog-title>
  Automatisk bevillingskontrol
  <mat-divider></mat-divider>
</h2>
<mat-dialog-content>
  <p>Automatisk bevillingskontrol godkender automatisk sager, som har ligget i bevillingskontrol i en given periode uden at blive agvist.</p>
  <form [formGroup]="form">
    <div>
      <mat-checkbox ngDefaultControl
        formControlName="list_projects"
        matTooltip="Listen indeholder titel, journalnr., ansøgt og bevilget beløb."
      >Inkluder liste med sager i mail.</mat-checkbox>
    </div>
    <div formGroupName="automatic">
      <div class="mb-2">
        <mat-checkbox ngDefaultControl  formControlName="enabled">Aktiver automatisk godkendelse</mat-checkbox>
      </div>
      @if (enabled.value === true) {
        <mat-form-field>
          <mat-label>Karensperiode</mat-label>
          <input
            type="number"
            matInput
            formControlName="grace"
            >
          <mat-hint>Antal dage i bevillingskontrol før automatisk godkendelse.</mat-hint>
          @if (grace.hasError('required')) {
            <mat-error><strong>Skal</strong> udfyldes.</mat-error>
          }
          @if (grace.hasError('min')) {
            <mat-error><strong>Mindst</strong> 1 dag.</mat-error>
          }
          @if (grace.hasError('max')) {
            <mat-error><strong>Højst</strong> 100 dage.</mat-error>
          }
        </mat-form-field>
      }
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Luk</button>
  <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
</mat-dialog-actions>
